<template>
  <v-snackbar v-model="show" :multi-line="true" :top="true" :right="true" :color="type">
    {{ $t(`${message}`) }}
    <br>
    ({{ message | capitalize }})
    <v-btn flat @click="close">
      close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    show: {
      get () {
        return this.$store.state.ui.toast.show
      },
      set () {
        return this.$store.dispatch('ui/closeToast')
      }
    },
    type () {
      return this.$store.state.ui.toast.type || 'success'
    },
    message () {
      return this.$store.state.ui.toast.message || 'empty'
    }
  },
  methods: {
    close () {
      return this.$store.dispatch('ui/closeToast')
    }
  }
}
</script>
